import { Dispatch } from 'react'
import { localStorageKey } from '../components/WalletModal/config'

export const clearUserStates = (dispatch: Dispatch<any>, isDeactive = false) => {
  if (isDeactive) {
    window.localStorage.removeItem(localStorageKey)
  }
}
